<script setup>
const props = defineProps({
    contentBoxConfig: {
        type: Object,
        required: false,
        default: () => ({}),
        validator: (rawValue) => {
            const validations = {
                isValidType: rawValue => rawValue?.type === undefined || (typeof rawValue?.type === 'string' && ['small'].includes(rawValue.type)),
                isValidPlaceholder: rawValue => rawValue?.placeholder === undefined || typeof rawValue?.placeholder === 'boolean'
            }

            return Object.entries(validations).every(([_, validation]) => validation(rawValue))
        }
    }
})

const getContentBoxClass = computed(() => {
    return {
        'content-box-small': props.contentBoxConfig?.type === 'small',
        'skeleton-placeholder-container': props.contentBoxConfig?.placeholder
    }
})
</script>

<template>
    <article class="content-box" :class="getContentBoxClass">
        <slot />
    </article>
</template>

<style lang="scss">
.content-box {
    border-radius: 24px;
    padding: 24px 32px;
    background: $content-box-bg;
    display: flex;
    flex-flow: row wrap;

    @include bp(medium1) {
        &:not(.content-box-small) {
            padding: 40px 32px;
        }
    }

    &.content-box-select {
        cursor: pointer;
    }
}
</style>
